/*
 * @Author: Vic Li
 * @Date: 2021-12-07 11:46:44
 * @LastEditTime: 2023-01-06 16:47:18
 * @LastEditors: Amber
 * @Description: 后端微服务网关路由表
 * @FilePath: \hm-app-configd:\work\HM-V2\hm-app-main\src\plugin\axios\gateway.js
 *
 */
/**
 * @name 后端微服务网关路由表
 * @key 后端微服务名称
 * @value 网关路由路径
 */
const gateway = {
  // 新闻中心
  'hm-news-center': '/news/center',
  // 网站服务
  'hm-taxerawebsite': '/api/taxerawebsite',
  // 法规库-8207
  'hm-tax-regulatory': '/tax/regulatory',
  // 财税沙龙和华盟风采
  'hm-website-midway': '/website'
}

export default gateway



// WEBPACK FOOTER //
// ./src/plugin/axios/gateway.js